import { ReactElement } from 'react';
import { Button, Classes, Dialog } from '@blueprintjs/core';
import { CreateGuardian } from './create-guardian';
import { Guardian } from '@techshift/callie-private-api-typescript';

export type CreateGuardianDialogProps = {
	userId: string;
	isOpen?: boolean;
	onSuccess?: (guardian: Guardian) => void;
	onClose?: () => void;
};
export function CreateGuardianDialog(
	props: CreateGuardianDialogProps
): ReactElement {
	const { userId, isOpen, onSuccess, onClose } = props;

	return (
		<Dialog isOpen={isOpen}>
			<div className={Classes.DIALOG_BODY}>
				<CreateGuardian userId={userId} onSuccess={onSuccess} />
			</div>
			<div className={Classes.DIALOG_FOOTER}>
				<div className={Classes.DIALOG_FOOTER_ACTIONS}>
					<Button onClick={onClose}>Close</Button>
				</div>
			</div>
		</Dialog>
	);
}
